import React from "react";
import { Link } from "react-router-dom";
import Classes from "./ServicePage.module.css";
import { BOOKING_URL, CITY_GROUPS } from "./serviceData";

// Cities grouped into one panel per county, plus the booking CTA. Used on the homepage
// and on the dryer vent and appliance repair pages. Cities come from src/content/cities/.
export default function ServiceAreas() {
    return (
        <section className={`${Classes.page} ${Classes.band} ${Classes.bandGray} ${Classes.bandAreas}`} id="service-areas">
            <div className={Classes.inner}>
                <div className={Classes.sectionHead}>
                    <p className={Classes.kicker}>Service Areas</p>
                    <h2>Serving Palm Beach and Broward Counties</h2>
                    <p>Based in Boca Raton, our technicians cover homes and condos from Lake Worth Beach to Pompano Beach.</p>
                </div>

                <div className={Classes.countyGrid}>
                    {CITY_GROUPS.map((group) => (
                        <div key={group.county} className={Classes.countyPanel}>
                            <div className={Classes.countyHead}>
                                <span className={Classes.areaPin} aria-hidden="true">
                                    <svg viewBox="0 0 24 24">
                                        <path d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z" />
                                    </svg>
                                </span>
                                <h3>{group.county}</h3>
                            </div>
                            <ul className={Classes.cityList}>
                                {group.links.map((c) => (
                                    <li key={c.path}>
                                        <Link to={c.path}>
                                            {c.label}
                                            <span aria-hidden="true">→</span>
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                <div className={Classes.sectionCta}>
                    <a className={Classes.primaryBtn} href={BOOKING_URL} target="_blank" rel="noreferrer">
                        Book in your city
                    </a>
                </div>
                <p className={Classes.areaNote}>
                    Don't see your city? <Link to="/contact">Contact us</Link> and we'll let you know if we can help.
                </p>
            </div>
        </section>
    );
}
